<template>
    <div class="recipe-content-section">
        <fade-up-animation :element="() => $refs.actions">
            <div class="actions-container" ref="actions">
                <div
                    v-if="backButtonLink"
                    class="btn-container"
                >
                    <b-button
                        variant="outline-primary"
                        class="back-btn"
                        :to="backButtonLink"
                        v-test:backBtn
                    >
                        <app-icon name="chevron-left" />
                        <span class="btn-text">{{ $snippet('back', 'back') }}</span>
                    </b-button>
                </div>

                <span
                    class="h5 section-name"
                    v-test:sectionName
                >
                    {{ sectionName }}
                </span>
            </div>
        </fade-up-animation>

        <recipe-header
            :mobile-image="mobileImage"
            :desktop-image="desktopImage"
            :make-me-veggie-url="makeMeVeggieUrl"
            :products="products"
            :name="name"
            :recipe-details="recipeDetails"
            :where-to-buy-link="whereToBuyLink"
        />

        <recipe-details-section
            :ingredients="ingredients"
            :instructions="instructions"
        />

        <section
            v-if="readMore.buttonText && readMore.content"
            class="read-more-container"
        >
            <b-container>
                <read-more
                    :button-text="readMore.buttonText"
                    :content="readMore.content"
                />
            </b-container>
        </section>
    </div>
</template>

<script>
    import RecipeHeader from '../../molecules/RecipeHeader/RecipeHeader';
    import RecipeDetailsSection from '../RecipeDetailsSection/RecipeDetailsSection';
    import ReadMore from '../../molecules/ReadMore/ReadMore';

    export default {
        name: 'recipe-content-section',

        components: { RecipeHeader, RecipeDetailsSection, ReadMore },

        props: {
            sectionName: {
                type: String,
                required: true,
            },

            name: {
                type: String,
                required: true,
            },

            recipeDetails: {
                type: Object,
                required: true,
            },

            products: {
                type: Array,
                default: () => ([]),
            },

            mobileImage: {
                type: Object,
                default: () => ({}),
            },

            desktopImage: {
                type: Object,
                required: true,
            },

            ingredients: {
                type: Array,
                default: () => ([]),
            },

            instructions: {
                type: Object,
                default: () => ({}),
            },

            whereToBuyLink: {
                type: String,
                default: '',
            },

            makeMeVeggieUrl: {
                type: String,
                default: '',
            },

            backButtonLink: {
                type: String,
                default: '',
            },

            readMore: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .recipe-content-section {
        padding-bottom: 100px;
    }

    .actions-container {
        position: relative;
        display: flex;
        padding: 15px;
        align-items: center;

        @include media-breakpoint-up(lg) {
            padding: 15px;
            justify-content: left;
        }
    }

    .btn-container {
        margin-right: 15px;
    }

    .back-btn {
        position: relative;
        font-weight: 300;
        text-align: left;
        min-width: 76px;
        padding: 7px 11px 5px;

        @include media-breakpoint-up(lg) {
            padding: 6px 15px;
            font-size: rem(18px);
            font-weight: 400;
        }

        svg {
            @include media-breakpoint-up(lg) {
                margin-right: 28px;
            }
        }
    }

    .btn-text {
        @include media-breakpoint-up(lg) {
            position: relative;
            top: 2px;
        }
    }

    .section-name {
        margin-bottom: 0;
        display: inline-block;

        @include media-breakpoint-up(lg) {
            display: none;
        }
    }

    .read-more-container {
        margin-top: 25px;
    }
</style>
